import { PHShape } from "../../plugins/global/PlaceholderPlugin";
import BaseScene from "../../scenes/BaseScene";
import EndlessRunnerScene, { Depths } from "../../scenes/EndlessRunnerScene";
import ImageButton from "../ImageButton";

export default class PauseScreen extends Phaser.GameObjects.Container {
  // a container is much like a html element, it has a parent (possible the scene or game world), and can have childen added via this.add

  scene: BaseScene;
  bg: Phaser.GameObjects.Image;
  home: Phaser.GameObjects.Image;
  restart: Phaser.GameObjects.Image;
  resume: Phaser.GameObjects.Image;
  sound: Phaser.GameObjects.Image;
  voiceover: Phaser.GameObjects.Image;

  scoreText: Phaser.GameObjects.Text;
  popupTarget: string;

  scoreValue: number = 0;
  scoreTween: Phaser.Tweens.Tween;

  constructor(
    scene: BaseScene,
    popupTarget?: string,
    score?: number,
    isGameOver?: boolean
  ) {
    // super to creat the container at the specified co-ordinates.
    super(scene, scene.cameras.default.centerX, scene.cameras.default.centerY);

    // !important - as we are using the 'new' keyword (and not using the scene
    // factory methods, `scene.add` ) we need to add it to the scene manually
    scene.add.existing(this);
    this.setDepth(Depths.UI);
    this.scene = scene;
    this.popupTarget = popupTarget != "" ? popupTarget : "pause-instructions";

    const blackout = scene.sponge.placeholder.image(
      scene,
      0,
      0,
      PHShape.RECT,
      {
        width: scene.cameras.default.width,
        height: scene.cameras.default.height,
        radius: 0,
      },
      0x000624
    );

    blackout.alpha = 0.8;

    scene.add.tween({
      targets: blackout,
      alpha: 0.7,
      yoyo: true,
      delay: 1000,
      duration: 6000,
    });

    this.bg = isGameOver
      ? scene.add.image(0, 0, "gameOverBox")
      : scene.add.image(0, 0, "runner-atlas", "pause-bg.png");

    this.restart = scene.add.image(
      0,
      isGameOver ? 190 : -80,
      "runner-atlas",
      "pause-screen-button-up.png"
    );
    this.home = scene.add.image(
      0,
      isGameOver ? 370 : 70,
      "runner-atlas",
      "pause-screen-button-up.png"
    );

    this.restart.setInteractive({ useHandCursor: true });
    this.home.setInteractive({ useHandCursor: true });

    this.restart.on("pointerup", () => {
      this.emit("restartPressed");
      this.destroy();
    });

    this.home.on("pointerup", () => {
      this.emit("closeAndGoHome");
      this.destroy();
    });

    this.home.on("pointerover", () => {
      this.overButt(this.home);
    });
    this.home.on("pointerout", () => {
      this.outButt(this.home);
    });
    this.restart.on("pointerover", () => {
      this.overButt(this.restart);
    });
    this.restart.on("pointerout", () => {
      this.outButt(this.restart);
    });

    const restartIcon = scene.add.image(
      this.restart.x - 140,
      this.restart.y,
      "runner-atlas",
      "icon-restart.png"
    );
    const restartText = scene.add
      .text(
        this.restart.x - 50,
        this.restart.y,
        scene.sponge.data.model.content.strings.restart,
        scene.sponge.data.model.fonts.pauseButton
      )
      .setOrigin(0, 0.5);

    const homeIcon = scene.add.image(
      this.home.x - 140,
      this.home.y,
      "runner-atlas",
      "icon-home.png"
    );
    const homeText = scene.add
      .text(
        this.home.x - 50,
        this.home.y,
        scene.sponge.data.model.content.strings.home,
        scene.sponge.data.model.fonts.pauseButton
      )
      .setOrigin(0, 0.5);

    this.add([
      blackout,
      this.bg,
      this.restart,
      this.home,
      restartIcon,
      restartText,
      homeIcon,
      homeText,
    ]);

    if (score) {
      const scoreRounded = Math.round(score * 100) / 100;

      const bestScore = (scene.sponge.data.save.topScore = Math.max(
        scene.sponge.data.save.topScore,
        scoreRounded
      ));

      const scoreBg = scene.add.image(0, -170, "gameOverWhite");

      const bestBg = scene.add.image(0, 10, "gameOverWhite");

      scene.sponge.tracking.save();

      this.scoreText = scene.add
        .text(
          0,
          -170,
          scene.sponge.data.model.content.strings.score + "0",
          scene.sponge.data.model.fonts.pauseButton
        )
        .setOrigin(0.5)
        .setFill("#000624")
        .setFontStyle("900");

      const bestText = scene.add
        .text(
          0,
          10,
          scene.sponge.data.model.content.strings.best + `${bestScore}`,
          scene.sponge.data.model.fonts.pauseButton
        )
        .setOrigin(0.5)
        .setFill("#000624")
        .setFontStyle("900");

      this.add([scoreBg, bestBg, this.scoreText, bestText]);

      this.scoreTween = scene.add.tween({
        targets: this,
        scoreValue: scoreRounded,
        duration: 3000,
        onUpdate: () => {
          this.scoreText.setText(
            scene.sponge.data.model.content.strings.score +
              `${Math.floor(this.scoreValue)}`
          );
        },
      });

      // Track score to LMS
      scene.sponge.tracking.complete();
      scene.sponge.tracking.save();

      //end game instructions.

      if (scene.sponge.data.save.seenInstructions.indexOf("end-game") === -1) {
        //show instructions
        scene.sponge.popup.launchPopup("end-game", () => {
          // scene.sponge.data.save.seenInstructions.push("end-game");
          // scene.sponge.tracking.save();
        });
      }
    } else if (!isGameOver) {
      this.resume = scene.add.image(
        0,
        -230,
        "runner-atlas",
        "pause-screen-button-up.png"
      );
      this.sound = scene.add.image(
        0,
        220,
        "runner-atlas",
        "pause-screen-button-up.png"
      );
      this.voiceover = scene.add.image(
        0,
        370,
        "runner-atlas",
        "pause-screen-button-up.png"
      );
      this.sound.setInteractive({ useHandCursor: true });
      this.voiceover.setInteractive({ useHandCursor: true });
      this.resume.setInteractive({ useHandCursor: true });

      this.resume.on("pointerover", () => {
        this.overButt(this.resume);
      });
      this.resume.on("pointerout", () => {
        this.outButt(this.resume);
      });

      this.resume.on("pointerup", () => {
        this.emit("resumePressed");
        this.destroy();
      });

      this.sound.on("pointerover", () => {
        this.overButt(this.sound);
      });
      this.sound.on("pointerout", () => {
        this.outButt(this.sound);
      });
      this.voiceover.on("pointerover", () => {
        this.overButt(this.voiceover);
      });
      this.voiceover.on("pointerout", () => {
        this.outButt(this.voiceover);
      });

      this.sound.on("pointerup", () => {
        // set sound params
        this.toggleAudio();
      });
      this.voiceover.on("pointerup", () => {
        // set sound params
        this.toggleVOAudio();
      });

      const soundIcon = scene.add.image(
        this.sound.x - 140,
        this.sound.y,
        "soundIcon"
      );

      const voiceoverIcon = scene.add.image(
        this.voiceover.x - 140,
        this.voiceover.y,
        "soundIcon"
      );

      this.sound.setData("icon", soundIcon);
      this.setAudioEnabled();

      this.voiceover.setData("icon", voiceoverIcon);
      this.setVOAudioEnabled();

      const soundText = scene.add
        .text(
          this.sound.x - 50,
          this.sound.y,
          scene.sponge.data.model.content.strings.sound,
          scene.sponge.data.model.fonts.pauseButton
        )
        .setOrigin(0, 0.5);

      const voiceoverText = scene.add
        .text(
          this.voiceover.x - 50,
          this.voiceover.y,
          scene.sponge.data.model.content.strings.voiceover,
          scene.sponge.data.model.fonts.voButton
        )
        .setOrigin(0, 0.5);

      const resumeIcon = scene.add.image(
        this.resume.x - 140,
        this.resume.y,
        "runner-atlas",
        "icon-resume.png"
      );
      const resumeText = scene.add
        .text(
          this.resume.x - 50,
          this.resume.y,
          scene.sponge.data.model.content.strings.resume,
          scene.sponge.data.model.fonts.pauseButton
        )
        .setOrigin(0, 0.5);

      const infoButton = new ImageButton(
        scene,
        0,
        550,
        this.scene.sponge.data.content.strings.instButtLabel,
        () => {
          this.scene.sponge.popup.launchPopup(this.popupTarget, () => {
            this.update();
          });
        },
        "submitButton"
      );
      this.add([
        this.resume,
        resumeIcon,
        resumeText,
        this.sound,
        soundIcon,
        soundText,
        this.voiceover,
        voiceoverIcon,
        voiceoverText,
        infoButton,
      ]);
    }
  }

  overButt(bg: Phaser.GameObjects.Image) {
    bg.setTexture("runner-atlas", "pause-screen-button-down.png");
  }

  outButt(bg: Phaser.GameObjects.Image) {
    bg.setTexture("runner-atlas", "pause-screen-button-up.png");
  }

  toggleAudio() {
    if (this.scene.sponge.data.save.audioEnabled) {
      this.scene.sponge.data.save.audioEnabled = false;
      this.scene.sound.mute = true;
    } else {
      this.scene.sponge.data.save.audioEnabled = true;
      this.scene.sound.mute = false;
    }
    this.setAudioEnabled();
  }

  setAudioEnabled() {
    this.sound.data.values.icon.setFrame(
      this.scene.sponge.data.save.audioEnabled ? 0 : 1
    );
  }

  toggleVOAudio() {
    if (this.scene.sponge.data.save.voEnabled) {
      this.scene.sponge.data.save.voEnabled = false;
    } else {
      this.scene.sponge.data.save.voEnabled = true;
    }
    this.setVOAudioEnabled();
  }

  setVOAudioEnabled() {
    this.voiceover.data.values.icon.setFrame(
      this.scene.sponge.data.save.voEnabled ? 0 : 1
    );
  }

  destroy() {
    if (this.scoreTween) {
      this.scoreTween.stop();
      // this.scoreTween.destroy();
    }
    super.destroy();
  }

  update(): void {
    // const delta = this.scene.time.
  }
}
